import { BaseCard, BaseTooltip } from '@/shared/components'
import { Skeleton } from '@/shared/components/shadcn'
import { ReactElement } from 'react'
import { Link } from 'react-router-dom'

export type DashboardCardModel = {
  id: number
  title: string
  value?: string
  date?: string
  tooltip?: string
  transactionsCount?: number
  linkName?: string
  link?: string
  button?: ReactElement
}

export const DashboardCard = ({
  card,
  isLoading,
}: {
  card: DashboardCardModel
  isLoading: boolean
}) => {
  const { id, title, value, date, link, linkName, tooltip, transactionsCount, button } = card

  return (
    <BaseCard key={id} variant="secondary" radius="lg" className="w-full">
      {isLoading ? (
        <div className="flex flex-col gap-y-4 w-full">
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <Skeleton className="w-10 h-6" />
              <Skeleton className="w-6 h-6" />
            </div>
            <Skeleton className="w-7 h-6" />
          </div>
          <div className="flex flex-col justify-center gap-y-1">
            <Skeleton className="w-1/4 h-8" />
            <Skeleton className="w-1/3 h-4" />
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-y-4 w-full">
          <div className="flex justify-between gap-1">
            <div className="flex items-center gap-1 text-text-secondary">
              {title}
              {tooltip && <BaseTooltip text={tooltip} />}
            </div>
            {link && (
              <Link to={link} className="text-primary text-sm">
                {linkName}
              </Link>
            )}
            {button}
          </div>
          <div className="flex flex-col justify-center gap-y-1">
            <div className="font-medium text-xl">{value}</div>
            {date && <div className="text-text-secondary text-sm">{date}</div>}
            {transactionsCount !== undefined && (
              <div className="text-text-secondary text-sm">
                Кол-во транзакций: {transactionsCount}
              </div>
            )}
          </div>
        </div>
      )}
    </BaseCard>
  )
}
